module.exports = __webpack_public_path__ + "img/burst-right.d9b1cc86.png";